module.exports = __webpack_public_path__ + "static/img/1.d4c0ed8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/1.png
// module id = lTXY
// module chunks = 0